import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { AiChatPanel } from "./AiChatPanel";

export function FloatingChat() {
  const [open, setOpen] = useState(false);

  // Close on Escape
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  // Allow other components (e.g. ConnectBand) to open the AI panel directly.
  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener("open-ai-chat", onOpen);
    return () => window.removeEventListener("open-ai-chat", onOpen);
  }, []);

  return (
    <div
      className={cn(
        "fixed right-4 z-40 flex flex-col items-end gap-3",
        "bottom-20 md:bottom-6",
      )}
    >
      {open && <AiChatPanel onClose={() => setOpen(false)} />}

      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Close chat" : "Open AI chat"}
        aria-expanded={open}
        className={cn(
          "inline-flex h-14 w-14 items-center justify-center rounded-full shadow-soft transition-transform",
          "bg-primary text-primary-foreground hover:scale-105",
        )}
      >
        {open ? <X className="h-6 w-6" /> : <MessageCircle className="h-6 w-6" />}
      </button>
    </div>
  );
}
